var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"2.47.0"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/assets/beta/socios-web";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
import { initSentryClient } from '@capsicum/common/logger';
import { BrowserProfilingIntegration, browserTracingIntegration, replayIntegration } from '@sentry/nextjs';

import packageJson from './package.json';

initSentryClient({
	integrations: [
		browserTracingIntegration(),
		BrowserProfilingIntegration(),
		replayIntegration({
			maskAllInput: true,
			maskAllText: true,
			useCompression: false
		})
	],
	platformType: 'client',
	version: packageJson.version
});
